import { useEffect, useState } from "react";
import { Zap, Moon, ChevronDown, NotebookPen } from "lucide-react";
import { toast } from "sonner";
import api from "../api";

const Scale = ({ label, Icon, value, onChange, testid }) => (
  <div className="flex items-center gap-2">
    <span className="text-[10px] uppercase tracking-wider text-[#B0B0B4] w-16">{label}</span>
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} data-testid={`${testid}-${n}`} onClick={() => onChange(value === n ? null : n)}
          className={`w-9 h-9 flex items-center justify-center border transition-colors ${
            value >= n ? "border-[#FF3B30] text-[#FF3B30] bg-[#FF3B30]/10" : "border-[#2E2E3A] text-[#555]"}`}>
          <Icon size={15} />
        </button>
      ))}
    </div>
  </div>
);

export const SessionJournal = ({ date, bloc, jour }) => {
  const [open, setOpen] = useState(false);
  const [energie, setEnergie] = useState(null);
  const [sommeil, setSommeil] = useState(null);
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [hasEntry, setHasEntry] = useState(false);

  useEffect(() => {
    setEnergie(null); setSommeil(null); setNotes(""); setHasEntry(false);
    api.get("/journal", { params: { date, bloc, jour } }).then(({ data }) => {
      if (data) {
        setEnergie(data.energie);
        setSommeil(data.sommeil);
        setNotes(data.notes || "");
        setHasEntry(true);
      }
    }).catch(() => {});
  }, [date, bloc, jour]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/journal", { date, bloc, jour, energie, sommeil, notes: notes || null });
      setHasEntry(true);
      toast.success("Journal enregistré");
    } catch (e) {
      toast.error("Erreur d'enregistrement du journal");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-[#14141A] border border-[#2E2E3A]" data-testid="session-journal">
      <button data-testid="journal-toggle" onClick={() => setOpen(!open)}
        className="w-full px-4 py-3 flex items-center gap-2 text-left hover:bg-white/5 transition-colors">
        <NotebookPen size={16} className="text-[#FF3B30]" />
        <span className="text-white text-sm font-medium flex-1">Journal de séance {hasEntry && <span className="text-[#32D74B] text-xs">· rempli</span>}</span>
        <ChevronDown size={16} className={`text-[#B0B0B4] transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3">
          <Scale label="Énergie" Icon={Zap} value={energie} onChange={setEnergie} testid="journal-energie" />
          <Scale label="Sommeil" Icon={Moon} value={sommeil} onChange={setSommeil} testid="journal-sommeil" />
          <textarea data-testid="journal-notes" rows={3} placeholder="Sensations, douleurs, motivation..."
            className="w-full bg-[#14141A] border border-[#2E2E3A] text-white text-sm p-3 focus:outline-none focus:border-[#FF3B30] resize-none"
            value={notes} onChange={(e) => setNotes(e.target.value)} />
          <button data-testid="journal-save-button" disabled={saving} onClick={save}
            className="h-10 px-4 bg-[#FF3B30] text-white text-sm font-semibold hover:bg-[#e0322a] transition-colors disabled:opacity-40">
            {saving ? "..." : "Enregistrer le journal"}
          </button>
        </div>
      )}
    </div>
  );
};
